/**
 * Created by patricsherif on 23.06.15.
 */
'use strict';

angular.module('mobile-apps')
    .factory('LockEntry', ['$resource',
        function($resource) {
            return $resource(
                '/v1/projects/:mobileAppId/languages/:languageId/entries/:entryId/:action',
                {
                    mobileAppId: '@mobileAppId',
                    languageId : '@languageId',
                    entryId    : '@entryId'
                },
                {
                    lockAll:
                    {
                        url : '/v1/projects/:mobileAppId/entries/:entryId/:action',
                        method:'PUT',
                        cache: false,
                        params :{action:'lock'}
                    },
                    unlockAll:
                    {
                        url : '/v1/projects/:mobileAppId/entries/:entryId/:action',
                        method:'PUT',
                        cache: false,
                        params :{action:'unlock'}
                    },
                    lock:
                    {
                        method:'PUT',
                        cache: false,
                        params :{action:'lock'}
                    },
                    unlock:
                    {
                        method:'PUT',
                        cache: false,
                        params :{action:'unlock'}
                    }
                });
        }
    ]);
